import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CurrencyCtx = createContext({ currency: "ZMW", setCurrency: () => {}, rates: {}, format: (v) => v });

const DEFAULTS = { zmw_per_usd: 26.5, zmw_per_cny: 3.7 };
const SYMBOLS = { ZMW: "K", USD: "$", CNY: "¥" };

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("easystay_currency") || "ZMW");
  const [rates, setRates] = useState(DEFAULTS);

  useEffect(() => {
    axios.get(`${API}/fx`).then(({ data }) => setRates({
      zmw_per_usd: data.zmw_per_usd || DEFAULTS.zmw_per_usd,
      zmw_per_cny: data.zmw_per_cny || DEFAULTS.zmw_per_cny,
    })).catch(() => {});
  }, []);

  const value = useMemo(() => {
    const setCurrency = (c) => {
      setCurrencyState(c);
      localStorage.setItem("easystay_currency", c);
    };
    const format = (zmwAmount) => {
      const n = Number(zmwAmount) || 0;
      if (currency === "USD") {
        const usd = n / (rates.zmw_per_usd || DEFAULTS.zmw_per_usd);
        return `${SYMBOLS.USD}${usd.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
      if (currency === "CNY") {
        const cny = n / (rates.zmw_per_cny || DEFAULTS.zmw_per_cny);
        return `${SYMBOLS.CNY}${cny.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
      return `${SYMBOLS.ZMW}${n.toLocaleString("en-ZM", { maximumFractionDigits: 0 })}`;
    };
    // Backwards-compat single-rate shim so components using `rate` (ZMW-per-USD) keep working.
    return { currency, setCurrency, rate: rates.zmw_per_usd, rates, format };
  }, [currency, rates]);

  return (
    <CurrencyCtx.Provider value={value}>
      {children}
    </CurrencyCtx.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyCtx);
